export enum ParameterType {
  String = 'String',
  Number = 'Number',
  Boolean = 'Boolean',
  Date = 'Date',
  ValueExpression = 'ValueExpression',
  ContextSetting = 'ContextSetting',
  DataAccessByObjectType = 'DataAccessByObjectType',
  DataAccessByValue = 'DataAccessByValue',
  PicklistByColumn = 'PicklistByColumn',
  PicklistByName = 'PicklistByName',
  Query = 'Query',
}

export class ParameterDefinition {
  Name: string;
  IsUserCreated: boolean;
  Type: ParameterType;
  Caption?: string;
  Description?: string;
  IsFixed?: boolean;
  IsRequired?: boolean;
  BeginGroup?: boolean;
  GroupCaption?: string;
  SortIndex?: number;
  AllowMultiSelect?: boolean;
  Value?: any;
  MinNumberValue?: number;
  MaxNumberValue?: number;
  MinDateValue?: string;
  MaxDateValue?: string;
  EditMask?: string;
  DataArgument?: string;
  DataArgument2?: string;
  DataQuery?: unknown;
}
